import { useEffect, useState } from 'react';

import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

const WEB_APP_VERSION_FALLBACK = '3.1.5';
const UNKNOWN_APP_VERSION = 'unknown';

const normalizeAppVersion = (version: string | null | undefined): string => {
  const trimmedVersion = version?.trim();

  if (!trimmedVersion) return UNKNOWN_APP_VERSION;

  const segments = trimmedVersion.split('.').filter(Boolean);

  while (segments.length > 2 && segments.at(-1) === '0') {
    segments.pop();
  }

  return segments.join('.') || UNKNOWN_APP_VERSION;
};

export const useAppVersion = (): string => {
  const [appVersion, setAppVersion] = useState<string>(
    normalizeAppVersion(WEB_APP_VERSION_FALLBACK),
  );

  useEffect(() => {
    let cancelled = false;

    const loadAppVersion = async () => {
      if (!Capacitor.isNativePlatform()) {
        if (!cancelled) {
          setAppVersion(normalizeAppVersion(WEB_APP_VERSION_FALLBACK));
        }
        return;
      }

      try {
        const info = await App.getInfo();

        if (!cancelled) {
          setAppVersion(normalizeAppVersion(info.version || WEB_APP_VERSION_FALLBACK));
        }
      } catch (error) {
        console.error('[AppVersion] Error obteniendo versión de la app', error);

        if (!cancelled) {
          setAppVersion(normalizeAppVersion(WEB_APP_VERSION_FALLBACK));
        }
      }
    };

    void loadAppVersion();

    return () => {
      cancelled = true;
    };
  }, []);

  return appVersion;
};
